import React, { useState, useEffect } from "react";
import ProductSale from "./ProductSale";
import DoctorSale from "./DoctorSale";
import DistributorSale from "./DistributorSale";
import {
  getDistributorSales,
  getDoctorSales,
  getProductSales,
} from "../../actions/SalesActions";
import {
  getDistributorSale,
  getDoctorSale,
  getProductSale,
} from "../../services/salesService";

const SalesOverview = ({ handleViewAction, setSubtab, userRole }) => {
  const [activeTab, setActiveTab] = useState("distributor");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [data, setData] = useState([]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     let result = [];
  //     if (activeTab === "distributor") {
  //       result = await getDistributorSales();
  //     } else if (activeTab === "doctor") {
  //       result = await getDoctorSales();
  //     } else if (activeTab === "product") {
  //       result = await getProductSales();
  //     }

  //     setData(result.data);
  //     setCurrentPage(result.currentPage);
  //     setTotalCount(result.totalCount);
  //     setTotalPages(result.totalPages);
  //   };

  //   fetchData();
  // }, [activeTab]);

  const getSalesDetails = async () => {
    setData([]);
    let result = [];
    if (activeTab === "distributor") {
      result = await getDistributorSale({
        category: "sales tracking",
        page_size: 5,
        page_number: currentPage,
      });
    } else if (activeTab === "doctor") {
      result = await getDoctorSale({
        category: "sales tracking",
        page_size: 5,
        page_number: currentPage,
      });
    } else if (activeTab === "product") {
      result = await getProductSale({
        category: "sales tracking",
        page_size: 5,
        page_number: currentPage,
      });
    }
    console.log(result);
    setData(result.data.response_data);
    setCurrentPage(result.data.page_number);
    setTotalCount(result.data.total_items);
    setTotalPages(result.data.page_size);
  };

  useEffect(() => {
    getSalesDetails();
  }, [activeTab, currentPage]);
  return (
    <div className="px-0 sm:px-4 mt-6">
      <div className="tabs flex border border-t-0 border-l-0 border-r-0">
        {[
          { key: "distributor", label: "Distributor Sale" },
          { key: "doctor", label: "Doctor Sale" },
          { key: "product", label: "Product Sale" },
        ].map((tab) => (
          <button
            key={tab.key}
            className={`mr-2 border ${
              activeTab === tab.key ? "tab active" : "tab inactive"
            }`}
            onClick={() => {
              setActiveTab(tab.key);
              setSubtab(tab.key);
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "distributor" && (
        <DistributorSale
          data={data}
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          setCurrentPage={setCurrentPage}
          handleViewAction={handleViewAction}
          userRole={userRole}
        />
      )}
      {activeTab === "doctor" && (
        <DoctorSale
          data={data}
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          setCurrentPage={setCurrentPage}
          handleViewAction={handleViewAction}
          userRole={userRole}
        />
      )}
      {activeTab === "product" && (
        <ProductSale
          data={data}
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          setCurrentPage={setCurrentPage}
          handleViewAction={handleViewAction}
          userRole={userRole}
        />
      )}
    </div>
  );
};

export default SalesOverview;
